import { gql } from '@apollo/client';
import {
	getAgbsQueryString,
	getCartQueryString,
	getCheckoutPriceDetailsQueryString,
	getCreditCardDetailsQueryString,
	getPersonalDataQueryString,
	getSepaMandatQueryString,
} from './utils';

export const getVignetteCheckoutProcessCollection = gql`
query getVignetteCheckout($lang: String, $slug: String) {
  vignettenCheckoutCollection(
    locale: $lang
    limit: 1
    where: { slug: { landList_contains: $slug } }
  ) {
    items {
      title(locale: $lang)
      checkoutHeadline
      checkoutChoosePayment
      checkoutPayment
      checkboxInvoice
      ${getPersonalDataQueryString()}
      ${getAgbsQueryString(false)}
      ${getCheckoutPriceDetailsQueryString(false)}
      ${getCreditCardDetailsQueryString()}
      ${getSepaMandatQueryString()}
      ${getCartQueryString()}
    }
  }
}
`;

// can be used as standard query once Content type migration is done
export const getVignetteCheckoutProcessOneCartCollection = gql`
query getVignetteCheckout($lang: String, $slug: String) {
  vignettenCheckoutCollection(
    locale: $lang
    limit: 1
    where: { slug: { landList_contains: $slug } }
  ) {
    items {
      title(locale: $lang)
      checkoutHeadline
      checkoutChoosePayment
      checkoutPayment
      checkboxInvoice
      ${getPersonalDataQueryString()}
      ${getAgbsQueryString(true)}
      ${getCheckoutPriceDetailsQueryString(true)}
      ${getCreditCardDetailsQueryString()}
      ${getSepaMandatQueryString()}
      ${getCartQueryString()}
    }
  }
}
`;
